import { PieChartOutlined, SmileOutlined } from '@ant-design/icons'

const menus = [
  {
    label: 'Overview',
    key: '/home/overview',
    icon: <PieChartOutlined />,
  },
  {
    label: '教师管理',
    key: '教师管理',
    icon: <SmileOutlined />,
    children: [
      { label: '教师表现', key: '/home/teacher-performance' },
      {
        label: '教师列表',
        key: '/home/teacher-list',
      },
      {
        label: '教师审核',
        key: '/home/teacher-review',
      },
      {
        label: '薪资发放',
        key: '/home/salary-payout',
      },
      {
        label: '教师合同',
        key: '/home/teacher-contracts',
      },
    ],
  },
  {
    label: '学生管理',
    key: '学生管理',
    icon: <SmileOutlined />,
    children: [
      {
        label: '学生列表',
        key: '/home/student-list',
      },
    ],
  },
  {
    label: '教材管理',
    key: '教材管理',
    icon: <SmileOutlined />,
    children: [
      {
        label: '教材分类',
        key: '/home/textbook-category-list',
      },
      {
        label: '教材列表',
        key: '/home/textbook-list',
      },
    ],
  },
  {
    label: '套餐管理',
    key: '套餐管理',
    icon: <SmileOutlined />,
    children: [
      {
        label: '套餐列表',
        key: '/home/package-list',
      },
      {
        label: '订单列表',
        key: '/home/order-list',
      },
      {
        label: '购卡列表',
        key: '/home/card-list',
      },
    ],
  },
  {
    label: '课程管理',
    key: '课程管理',
    icon: <SmileOutlined />,
    children: [
      {
        label: '课程记录',
        key: '/home/course-records',
      },
      {
        label: '未来预约',
        key: '/home/upcoming-appointments',
      },
      {
        label: '考勤复核',
        key: '/home/attendance-review',
      },
    ],
  },
  {
    label: '经销商管理',
    key: '经销商管理',
    icon: <SmileOutlined />,
    children: [
      {
        label: '经销商列表',
        key: '/home/agent-list',
      },
    ],
  },
]

export default menus
